import { StrictMode } from "react";
import { render } from "react-dom";
import { RecoilRoot } from "recoil";
import RecoilizeDebugger from "recoilize";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import RootContainer from "./containers/RootContainer";
import queryClient from "./services/queryClient";
import storage from "./utils/storage";
import buildInfo from "./utils/buildInfo";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import "./assets/datadog-instrumentation";
import "./styles/amplify.css";
import "./styles/fonts.css";
import "./styles/image-marker.css";
import "./styles/index.css";
import "./styles/mui.css";
import "./styles/react-editor.css";
import "./styles/uppy.css";

const root = document.getElementById("root");

render(
  <StrictMode>
    <RecoilRoot>
      <RecoilizeDebugger root={root} />
      <QueryClientProvider client={queryClient}>
        <RootContainer />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </RecoilRoot>
  </StrictMode>,
  root
);

if (storage.getItem("config.logger-version")) {
  console.log(
    `%cNotissia App v${buildInfo.version}-${buildInfo.timestamp} (${buildInfo.gitInfo.branch}/${buildInfo.gitInfo.commit})`,
    "color: #888"
  );
  console.log(
    `%c${
      buildInfo.envInfo.environment.charAt(0).toUpperCase() +
      buildInfo.envInfo.environment.slice(1)
    } Node ${buildInfo.envInfo.nodeVersion}-${buildInfo.osInfo.platform}${
      buildInfo.osInfo.arch
    } (${buildInfo.osInfo.hostname}/${buildInfo.osInfo.user})`,
    "color: #888"
  );
}
